import type { ILanguageResources, ITranslationModule } from '../../../../interfaces';
import { interpolate } from '../../../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.dealer-franchisee.clients.data.FranchiseeClientContainer.';
  public static readonly franchiseeClientIsNull = `${Id.prefix}franchiseeClientIsNull`;
  public static readonly clientPaymentProfileCorruptAndRecovered = `${Id.prefix}clientPaymentProfileCorruptAndRecovered`;
  public static readonly newClient = `${Id.prefix}newClient`;
}

export class LangDealerFranchiseeClientContainer {
  private constructor() {}
  public static franchiseeClientIsNull(): string {
    return interpolate(Id.franchiseeClientIsNull);
  }
  public static clientPaymentProfileCorruptAndRecovered(): string {
    return interpolate(Id.clientPaymentProfileCorruptAndRecovered);
  }
  public static newClient(): string {
    return interpolate(Id.newClient);
  }
}

export class DealerFranchiseeClientContainerModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(
      Id.franchiseeClientIsNull,
      'FranchiseeClient is null',
      'Error message when franchisee client is unexpectedly null'
    );
    register.add(
      Id.clientPaymentProfileCorruptAndRecovered,
      "{{glossary 'client'}} {{glossary 'payment-profile'}} corrupt and recovered",
      'Warning when client payment profile is corrupt and has been recovered'
    );
    register.add(Id.newClient, "New {{glossary 'client'}}", 'Default name for a new client');
  }
}
